import type {
  GetOnePriceOverrideResponse,
  PatchPriceOverride,
  PriceOverrideDB,
} from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { type Ref, unref } from "vue";
import type { UndefinedToNull } from "@/components/Account/types";
import { learningServiceRequest } from "@/services/utils";

export const getQueryKey = (id: Ref<string>) => ["patchPriceOverride", id];

type PartialUpdateOverrideArgs = {
  id: Ref<string>;
  payload: UndefinedToNull<PatchPriceOverride>;
  name?: string;
};

export const usePatchPriceOverride = (
  useMutationOptions?: UseMutationOptions<PriceOverrideDB, Error, PartialUpdateOverrideArgs>,
) => {
  return useMutation<PriceOverrideDB, Error, PartialUpdateOverrideArgs>({
    mutationFn: async ({ id, payload }) => {
      const response: AxiosResponse<GetOnePriceOverrideResponse> = await learningServiceRequest({
        method: "patch",
        url: `/price_overrides/${unref(id)}`,
        payload: payload,
      });
      return response.data.data;
    },
    ...useMutationOptions,
  });
};
